import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

/**
 * Dispara la disolución del splash de carga (definido en index.html) tras arrancar Angular.
 * El bootstrap se resuelve cuando el APP_INITIALIZER ya cargó la config del congreso, así que este
 * es el momento exacto en que la página está lista. Se respeta un tiempo mínimo en pantalla para que
 * no "parpadee" en cargas rápidas; la disolución (fundir blanco+logo y luego las ondas) la orquesta
 * el propio index.html en `__appSplashDissolve`.
 */
function removeAppSplash(): void {
   const dissolve = (window as any).__appSplashDissolve as (() => void) | undefined;

   if (typeof dissolve !== 'function') {
      // En admin el splash ya se autoeliminó; por si acaso, limpieza defensiva.
      ['app-splash-bg', 'app-splash-wave', 'app-splash-logo']
         .forEach((id) => document.getElementById(id)?.remove());
      return;
   }

   const MIN_MS = 1500;
   const start = (window as any).__appSplashStart ?? Date.now();
   const espera = Math.max(0, MIN_MS - (Date.now() - start));

   setTimeout(() => dissolve(), espera);
}

bootstrapApplication(AppComponent, appConfig)
   .then(() => removeAppSplash())
   .catch((err) => {
      console.error(err);
      removeAppSplash(); // que el splash no se quede colgado si el arranque falla
   });
